import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAccordion, LazyAgenda, LazyAnnouncementBanner, LazyAppPromo, LazyBlockStickyNavContainer, LazyBlogFilterGrid, LazyBlogAuthor, LazyBlogHeadline, LazyBlogHero, LazyBlogImageCarousel, LazyBlogQuote, LazyBlogRegistrationCta, LazyBlogThreeUp, LazyBlogVideo, LazyCircleCarousel, LazyCommunitiesGrid, LazyDecoratedSplitCta, LazyDescriptionCarousel, LazyFaq, LazyFestivalAccordion, LazyFullWidthImageTextTwoUp, LazyGoogleMap, LazyHeadlineCopyCta, LazyHeadline, LazyHelloWorld, LazyHeroSponsors, LazyHero, LazyHubspotFormEmbed, LazyIconGrid, LazyIconList, LazyIconTitleContent, LazyIframe, LazyImageBulletPointCarousel, LazyImageCollage, LazyImageContentAccordion, LazyImageContentCarousel, LazyImageTextCountdown, LazyImageTextCta, LazyImageTextSplit, LazyImageTextTwoUp, LazyManualEntryThreeUp, LazyManualEntryCarousel, LazyNarrowContainerParent, LazyNarrowImageThreeUp, LazyNewsletterSignup, LazyPullQuotes, LazyQuoteCarousel, LazyRegistrationSingle, LazyRegistration, LazyRegistrationForm, LazyRegistrationPanels, LazySessionSpeakerCarousel, LazySessionsAssistantBackup, LazySessionsAssistantSchedule, LazySessionsAssistant, LazySessionsByDay, LazySessionsCalendarCard, LazySessionsCalendarList, LazySessionsCard, LazySessionsGridList, LazySessionsHeader, LazySessionsRelated, LazySessionsSchedule, LazySessionsFeaturedCarousel, LazySessionsFilterGrid, LazySessionsList, LazySessionsLiveStreamCarousel, LazySessionsSingleDayViewBackground, LazySessionsSingleDayView, LazySessionsTargetedAgendaCarousel, LazySessionsThreeDayView, LazySessionsSpeakers, LazySessionsTags, LazySoldOutForm, LazySpeakersCard, LazySpeakersGridCard, LazySpeakersHeader, LazySpeakersImageWrapperBackup, LazySpeakersImageWrapper, LazySpeakersModal, LazySpeakersSessions, LazySpeakersFeaturedCarousel, LazySpeakersFilterGrid, LazySpeakersTags, LazySplitImageTextCta, LazySponsors, LazyStages, LazyStickyNav, LazyTestBlock, LazyVideoBackground, LazyVideoExpanding, LazyAccordianMinus, LazyAccordianPlus, LazyAppAndroid, LazyAppAndroidWhite, LazyAppApple, LazyAppAppleWhite, LazyBackArrowSmall, LazyBackArrow, LazyBackToTopArrow, LazyBack, LazyBlogFilter, LazyBlogSearch, LazyBluecircle, LazyBluecircleunfilled, LazyBullet, LazyCalendar, LazyCalendarApple, LazyCalendarGoogle, LazyCalendarOutlook, LazyCarouselArrow, LazyCarouselDot, LazyCarouselring, LazyCheckMark, LazyChevronDown, LazyChevronLeft, LazyChevronRight, LazyChevronUp, LazyClipboard, LazyClock, LazyClose, LazyCornerTriangleBlue, LazyCornerTriangle, LazyFacebook, LazyForwardArrowSmall, LazyForwardArrow, LazyGreenTearDrop, LazyGreenelipse, LazyGrid, LazyHalfcircle, LazyHeartFilled, LazyHeart, LazyInfo, LazyInformation, LazyInstagram, LazyLeftArrow, LazyLeftNarrowArrow, LazyLinkedIn, LazyLocation, LazyLogin, LazyLogo2025Short, LazyLogoHubspot, LazyLogoWideWithBorder, LazyLogoWide, LazyNavSearch, LazyOrangecircle, LazyOrangering, LazyPaginationLeft, LazyPaginationRight, LazyPdf, LazyPeachCirlce, LazyPlay, LazyProjectX, LazyQuote, LazyRedcircle, LazyRedtriangle, LazyRightArrow, LazySearch, LazySeatFilled, LazySeat, LazySessionsCalendar, LazySessionsGrid, LazySocialsFacebook, LazySocialsLinkedin, LazySocialsThreads, LazySocialsTiktok, LazySocialsTwitter, LazySocialsWebsite, LazySpeakersSocialsSBluesky, LazySpeakersSocialsSFacebook, LazySpeakersSocialsSInstagram, LazySpeakersSocialsSLink, LazySpeakersSocialsSLinkedin, LazySpeakersSocialsSThreads, LazySpeakersSocialsSTiktok, LazySpeakersSocialsSX, LazySpeakersSocialsSYoutube, LazyTagx, LazyTargetedTriangle, LazyTiktok, LazyTooltip, LazyTriangle, LazyTwitter, LazyWarning, LazyWhiteBackArrow, LazyX, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["Accordion", LazyAccordion],
["Agenda", LazyAgenda],
["AnnouncementBanner", LazyAnnouncementBanner],
["AppPromo", LazyAppPromo],
["BlockStickyNavContainer", LazyBlockStickyNavContainer],
["BlogFilterGrid", LazyBlogFilterGrid],
["BlogAuthor", LazyBlogAuthor],
["BlogHeadline", LazyBlogHeadline],
["BlogHero", LazyBlogHero],
["BlogImageCarousel", LazyBlogImageCarousel],
["BlogQuote", LazyBlogQuote],
["BlogRegistrationCta", LazyBlogRegistrationCta],
["BlogThreeUp", LazyBlogThreeUp],
["BlogVideo", LazyBlogVideo],
["CircleCarousel", LazyCircleCarousel],
["CommunitiesGrid", LazyCommunitiesGrid],
["DecoratedSplitCta", LazyDecoratedSplitCta],
["DescriptionCarousel", LazyDescriptionCarousel],
["Faq", LazyFaq],
["FestivalAccordion", LazyFestivalAccordion],
["FullWidthImageTextTwoUp", LazyFullWidthImageTextTwoUp],
["GoogleMap", LazyGoogleMap],
["HeadlineCopyCta", LazyHeadlineCopyCta],
["Headline", LazyHeadline],
["HelloWorld", LazyHelloWorld],
["HeroSponsors", LazyHeroSponsors],
["Hero", LazyHero],
["HubspotFormEmbed", LazyHubspotFormEmbed],
["IconGrid", LazyIconGrid],
["IconList", LazyIconList],
["IconTitleContent", LazyIconTitleContent],
["Iframe", LazyIframe],
["ImageBulletPointCarousel", LazyImageBulletPointCarousel],
["ImageCollage", LazyImageCollage],
["ImageContentAccordion", LazyImageContentAccordion],
["ImageContentCarousel", LazyImageContentCarousel],
["ImageTextCountdown", LazyImageTextCountdown],
["ImageTextCta", LazyImageTextCta],
["ImageTextSplit", LazyImageTextSplit],
["ImageTextTwoUp", LazyImageTextTwoUp],
["ManualEntryThreeUp", LazyManualEntryThreeUp],
["ManualEntryCarousel", LazyManualEntryCarousel],
["NarrowContainerParent", LazyNarrowContainerParent],
["NarrowImageThreeUp", LazyNarrowImageThreeUp],
["NewsletterSignup", LazyNewsletterSignup],
["PullQuotes", LazyPullQuotes],
["QuoteCarousel", LazyQuoteCarousel],
["RegistrationSingle", LazyRegistrationSingle],
["Registration", LazyRegistration],
["RegistrationForm", LazyRegistrationForm],
["RegistrationPanels", LazyRegistrationPanels],
["SessionSpeakerCarousel", LazySessionSpeakerCarousel],
["SessionsAssistantBackup", LazySessionsAssistantBackup],
["SessionsAssistantSchedule", LazySessionsAssistantSchedule],
["SessionsAssistant", LazySessionsAssistant],
["SessionsByDay", LazySessionsByDay],
["SessionsCalendarCard", LazySessionsCalendarCard],
["SessionsCalendarList", LazySessionsCalendarList],
["SessionsCard", LazySessionsCard],
["SessionsGridList", LazySessionsGridList],
["SessionsHeader", LazySessionsHeader],
["SessionsRelated", LazySessionsRelated],
["SessionsSchedule", LazySessionsSchedule],
["SessionsFeaturedCarousel", LazySessionsFeaturedCarousel],
["SessionsFilterGrid", LazySessionsFilterGrid],
["SessionsList", LazySessionsList],
["SessionsLiveStreamCarousel", LazySessionsLiveStreamCarousel],
["SessionsSingleDayViewBackground", LazySessionsSingleDayViewBackground],
["SessionsSingleDayView", LazySessionsSingleDayView],
["SessionsTargetedAgendaCarousel", LazySessionsTargetedAgendaCarousel],
["SessionsThreeDayView", LazySessionsThreeDayView],
["SessionsSpeakers", LazySessionsSpeakers],
["SessionsTags", LazySessionsTags],
["SoldOutForm", LazySoldOutForm],
["SpeakersCard", LazySpeakersCard],
["SpeakersGridCard", LazySpeakersGridCard],
["SpeakersHeader", LazySpeakersHeader],
["SpeakersImageWrapperBackup", LazySpeakersImageWrapperBackup],
["SpeakersImageWrapper", LazySpeakersImageWrapper],
["SpeakersModal", LazySpeakersModal],
["SpeakersSessions", LazySpeakersSessions],
["SpeakersFeaturedCarousel", LazySpeakersFeaturedCarousel],
["SpeakersFilterGrid", LazySpeakersFilterGrid],
["SpeakersTags", LazySpeakersTags],
["SplitImageTextCta", LazySplitImageTextCta],
["Sponsors", LazySponsors],
["Stages", LazyStages],
["StickyNav", LazyStickyNav],
["TestBlock", LazyTestBlock],
["VideoBackground", LazyVideoBackground],
["VideoExpanding", LazyVideoExpanding],
["AccordianMinus", LazyAccordianMinus],
["AccordianPlus", LazyAccordianPlus],
["AppAndroid", LazyAppAndroid],
["AppAndroidWhite", LazyAppAndroidWhite],
["AppApple", LazyAppApple],
["AppAppleWhite", LazyAppAppleWhite],
["BackArrowSmall", LazyBackArrowSmall],
["BackArrow", LazyBackArrow],
["BackToTopArrow", LazyBackToTopArrow],
["Back", LazyBack],
["BlogFilter", LazyBlogFilter],
["BlogSearch", LazyBlogSearch],
["Bluecircle", LazyBluecircle],
["Bluecircleunfilled", LazyBluecircleunfilled],
["Bullet", LazyBullet],
["Calendar", LazyCalendar],
["CalendarApple", LazyCalendarApple],
["CalendarGoogle", LazyCalendarGoogle],
["CalendarOutlook", LazyCalendarOutlook],
["CarouselArrow", LazyCarouselArrow],
["CarouselDot", LazyCarouselDot],
["Carouselring", LazyCarouselring],
["CheckMark", LazyCheckMark],
["ChevronDown", LazyChevronDown],
["ChevronLeft", LazyChevronLeft],
["ChevronRight", LazyChevronRight],
["ChevronUp", LazyChevronUp],
["Clipboard", LazyClipboard],
["Clock", LazyClock],
["Close", LazyClose],
["CornerTriangleBlue", LazyCornerTriangleBlue],
["CornerTriangle", LazyCornerTriangle],
["Facebook", LazyFacebook],
["ForwardArrowSmall", LazyForwardArrowSmall],
["ForwardArrow", LazyForwardArrow],
["GreenTearDrop", LazyGreenTearDrop],
["Greenelipse", LazyGreenelipse],
["Grid", LazyGrid],
["Halfcircle", LazyHalfcircle],
["HeartFilled", LazyHeartFilled],
["Heart", LazyHeart],
["Info", LazyInfo],
["Information", LazyInformation],
["Instagram", LazyInstagram],
["LeftArrow", LazyLeftArrow],
["LeftNarrowArrow", LazyLeftNarrowArrow],
["LinkedIn", LazyLinkedIn],
["Location", LazyLocation],
["Login", LazyLogin],
["Logo2025Short", LazyLogo2025Short],
["LogoHubspot", LazyLogoHubspot],
["LogoWideWithBorder", LazyLogoWideWithBorder],
["LogoWide", LazyLogoWide],
["NavSearch", LazyNavSearch],
["Orangecircle", LazyOrangecircle],
["Orangering", LazyOrangering],
["PaginationLeft", LazyPaginationLeft],
["PaginationRight", LazyPaginationRight],
["Pdf", LazyPdf],
["PeachCirlce", LazyPeachCirlce],
["Play", LazyPlay],
["ProjectX", LazyProjectX],
["Quote", LazyQuote],
["Redcircle", LazyRedcircle],
["Redtriangle", LazyRedtriangle],
["RightArrow", LazyRightArrow],
["Search", LazySearch],
["SeatFilled", LazySeatFilled],
["Seat", LazySeat],
["SessionsCalendar", LazySessionsCalendar],
["SessionsGrid", LazySessionsGrid],
["SocialsFacebook", LazySocialsFacebook],
["SocialsLinkedin", LazySocialsLinkedin],
["SocialsThreads", LazySocialsThreads],
["SocialsTiktok", LazySocialsTiktok],
["SocialsTwitter", LazySocialsTwitter],
["SocialsWebsite", LazySocialsWebsite],
["SpeakersSocialsSBluesky", LazySpeakersSocialsSBluesky],
["SpeakersSocialsSFacebook", LazySpeakersSocialsSFacebook],
["SpeakersSocialsSInstagram", LazySpeakersSocialsSInstagram],
["SpeakersSocialsSLink", LazySpeakersSocialsSLink],
["SpeakersSocialsSLinkedin", LazySpeakersSocialsSLinkedin],
["SpeakersSocialsSThreads", LazySpeakersSocialsSThreads],
["SpeakersSocialsSTiktok", LazySpeakersSocialsSTiktok],
["SpeakersSocialsSX", LazySpeakersSocialsSX],
["SpeakersSocialsSYoutube", LazySpeakersSocialsSYoutube],
["Tagx", LazyTagx],
["TargetedTriangle", LazyTargetedTriangle],
["Tiktok", LazyTiktok],
["Tooltip", LazyTooltip],
["Triangle", LazyTriangle],
["Twitter", LazyTwitter],
["Warning", LazyWarning],
["WhiteBackArrow", LazyWhiteBackArrow],
["X", LazyX],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
